import { Component, OnInit, Input } from '@angular/core';
import { BpgCommonService } from '../services/bpg-common.service';
import { DataService } from "../../bpg-common/services/data.services";
import { Router } from '@angular/router';
import { BpgAdminServices } from 'src/app/bpg-admin/bpg-admin-services';
import { SelfService } from 'src/app/bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-navigation-menu',
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.css']
})

export class NavigationMenuComponent implements OnInit {
  @Input() showPopUp: any;
  myBpgsData: any;
  logindata1: any;
  myBpgList: any;
  links: any;
  landingData: any;
  siteData: any;
  siteList: any;
  siteId: any;
  adminId: any;
  userRoleDetails: any;
  selectedSiteId: any;
  siteName: string;
  isClassVisible: boolean;
  selectedBpgList: any;
  userSiteId = localStorage.getItem('userSiteId');
  isSiteOrBpgCreated: boolean;
  userType: string;
  corporateType: string;
  leadAdminId: any;
  alertSuccess = false;
  email: any;
  naacAffinityList: any = [];
  publishedNaacList: any = [];
  loginData: any;
  userData: string;
  userIdDto: any;
  userEmail: any;
  userWorkDayID: any;
  isbpgAdmin = false;
  isNaacAdmin = false;
  chapterRoute = "/chapter-services";
  configureGallery = "Configure Gallery";
  configureGalleryRoute = "/configure-gallery";
  chapterResources = "Chapter Resources";
  chapterResourcesRoute = "/document-repository";
  chapterAnnouncement = "Chapter Announcement";
  chapterAnnouncementRoute = "/chapter-announcements";
  pushNotification = "Push Notification";
  pushNotificationRoute = "/push-notification";
  membershipReport = "Succession Planning";
  membershipReportRoute = "/succession-planning";
  emailManagement = 'Email Management';
  emailManagementRoute = '/email-management'
  groupSignUp = "Membership Group Sign Up";
  groupSignUpRoute = "/membership-group-sign-up";
  tnC = "/t&c"
  isbpgLeadAdmin = false;
  eventPopUpOpened: boolean;
  isSiteAffected = false;
  siteUpdated = false;
  oldSiteLocation = '';
  newSiteLocation = '';
  membershipsList: any = [];  
  leadershipsList: any = [];
  sitePreference = '';
  siteHomeRouteConstant = '/site-home';
  selfServicesConstant = "Self Services";
  manualSiteChange: boolean;
  loginSiteChange: boolean;
  constructor(private readonly bpgCommonService: BpgCommonService,
    private readonly router: Router,
    private readonly adminService: BpgAdminServices,
    private readonly selfService: SelfService,
    private readonly data: DataService,
    private readonly spinner: Ng4LoadingSpinnerService) {
    this.bpgCommonService.isSiteOrBpgCreated.subscribe(value => {
      this.isSiteOrBpgCreated = value;
      if (this.isSiteOrBpgCreated === true) {
        this.prepareMainMenu();
      }
    })
  }

  ngOnInit() {

    this.data.isEventPopupOpened.subscribe(data => this.eventPopUpOpened = data);
    this.data.selectedBpgList.subscribe(selectedBpgList => this.selectedBpgList = selectedBpgList);
    this.data.siteEffectedPopup.subscribe(data=>{
     if(data==='true'){
        this.siteEffectedData("manualSiteChange");
     }
    });
    this.userEmail = sessionStorage.getItem('userEmail') ? sessionStorage.getItem('userEmail') : '';

    const loginDto = {
      'firstName': sessionStorage.getItem('userFirstName') ? sessionStorage.getItem('userFirstName') : '',
      'lastName': sessionStorage.getItem('userLastName') ? sessionStorage.getItem('userLastName') : '',
      'email': sessionStorage.getItem('userEmail') ? sessionStorage.getItem('userEmail') : '',
      'createdBy': sessionStorage.getItem('userFirstName') && sessionStorage.getItem('userLastName') ? `${sessionStorage.getItem('userFirstName')} ${sessionStorage.getItem('userLastName')}` : '',
      'modifiedBy': sessionStorage.getItem('userFirstName') && sessionStorage.getItem('userLastName') ? `${sessionStorage.getItem('userFirstName')} ${sessionStorage.getItem('userLastName')}` : '',
      'accessToken': sessionStorage.getItem('access_token') ? sessionStorage.getItem('access_token') : ''
    } 
    const workdayId = sessionStorage.getItem('workdayId')
    this.bpgCommonService.loginMonitor(loginDto).subscribe(data => {
      if(data)
      {
        const emailDto = {
          "userEmailId": this.userEmail,
          "workdayId": workdayId
    
        }
        this.bpgCommonService.isTokenPresent.subscribe(tokenRes => {
          if (tokenRes) {
            this.bpgCommonService.userDetailsByEmailId(emailDto).subscribe(data => {
              this.loginData = data;
              if (data.emailId === null) {
                this.bpgCommonService.loginError.next(false);
                this.router.navigate(['/login-error']);
              } else {
    
                localStorage.setItem('loginData', JSON.stringify(this.loginData));
                this.userData = JSON.parse(localStorage.getItem('loginData'));
                // to emit data to bpg-header
                this.data.setUserDetails(this.userData);
                this.userIdDto = { "userId": this.userData['userId'] };
                this.bpgCommonService.setloggedInHeader();
                this.bpgCommonService.getUserRoleDetails(this.userIdDto).subscribe(data => {
    
                  this.userRoleDetails = data;
                  localStorage.setItem('isMultiChapterAdmin',this.loginData['isMultiChapterAdmin']);
                  localStorage.setItem('userSiteId', this.loginData['site']['siteId']);
                  localStorage.setItem('selectedSiteId', this.loginData['site']['siteId']);
                  localStorage.setItem('leadAdminId', this.userRoleDetails['leadAdminId']);
                  sessionStorage.setItem('emailAddressForMembership',this.loginData['emailId']);
                  if (this.userRoleDetails['adminId'].length === 1) {
                    localStorage.setItem('adminId', this.userRoleDetails['adminId'][0].toString())
                  }
                  if (this.userRoleDetails['adminId'].length > 1) {
                    const adminId = this.userRoleDetails['adminId'];
                    localStorage.setItem('adminId', adminId.toString());
                    for (const user of this.userRoleDetails['adminId']) {
                      if (user === 2) {
                        this.isbpgLeadAdmin = true;
                        localStorage.setItem('isbpgLeadAdmin', 'true');
                      }
                      if (user === 3) {
                        this.isbpgAdmin = true;
                        localStorage.setItem('isbpgAdmin', 'true');
                      }
                      if (user === 4) {
                        this.isNaacAdmin = true;
                        localStorage.setItem('isNaacAdmin', 'true');
                      }
    
    
                    }
    
                  }
    
                  this.logindata1 = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')) : '';
                  if (this.logindata1 !== undefined) {
                    if (this.logindata1.site === undefined || this.logindata1.site === null || this.logindata1.site === '') {
                      this.router.navigate(['/login-error'])
                    }
                    else {
                      if (this.logindata1.emailId === "" || this.logindata1.emailId === null) {
                        this.showPopUp = true;
                      }
                      if (localStorage.getItem('emailUpdated') === 'true') {
                        this.showPopUp = false;
                      }
    
                      this.userType = (this.logindata1.userType) ? this.logindata1.userType.trim() : '';
                      this.corporateType = (this.logindata1.corporatePartnerType !== null && this.logindata1.corporatePartnerType !== undefined) ? this.logindata1.corporatePartnerType.trim() : '';
    
    
                    }
                    this.siteEffectedData("loginSiteChange");
                    this.adminId = localStorage.getItem('adminId');
                    this.leadAdminId = localStorage.getItem('leadAdminId');
    
                    this.prepareMainMenu();
                    if (localStorage.getItem('loginData') != null) {
                      if (sessionStorage.getItem('firstLogin') === 'true') {
                        sessionStorage.setItem('firstLogin', 'false');
                        if (sessionStorage.getItem('landingPage') === 'eventDetails') {
                          const id = localStorage.getItem('eventId');
                          this.router.navigate(['/event-view-details', id]);
                        }
                        else if (sessionStorage.getItem('landingPage') === 'takeSurvey') {
                          const id = localStorage.getItem('surveyId');
                          this.router.navigate(['/take-survey', id]);
                        }
                        else if (sessionStorage.getItem('landingPage') === 'membershipSite') {
                          this.router.navigate(['/membership/site'])
                        }
                        else {
                          this.router.navigate(['/di-home']);
    
                        }
    
                      }
                    }
                  }
    
                })
              }
    
            })
          }
        })
      }
      else
      {
        this.router.navigate(['/log-out'])
      }
    })
  }
  siteEffectedData(flag:any) {
    const landingData = 
      {
        "filter": {
        "userId":this.userData['userId'],
        "flag": flag
        }
      }
      this.bpgCommonService.checkSiteAffected(landingData).subscribe(data => {
        if (data && data.isSiteAffected) {
            this.isSiteAffected = true;
            this.data.setBanner(false);
            this.oldSiteLocation = data.oldSiteName;
            this.newSiteLocation = data.newSiteName;
            this.membershipsList = data.membershipsList?data.membershipsList:[];
            this.leadershipsList = data.leadershipList?data.leadershipList:[];
            if(flag==="manualSiteChange"){
              this.manualSiteChange = true;
              this.loginSiteChange = false;
            }
            if(flag==="loginSiteChange"){
              this.manualSiteChange = false;
              this.loginSiteChange = true;
            }
        }
         else {
            this.isSiteAffected = false;
            this.data.setBanner(true);
         }
      });
  }


  updateSite() {
    this.spinner.show();
    this.data.siteAffectedPopup('false');
    let flag = '';
    if(this.manualSiteChange){
      flag = "manualSiteChange";
    }
    if(this.loginSiteChange){
      flag = "loginSiteChange";
    }

    const siteData = {
      'siteFlag': this.sitePreference,
      'userId': this.loginData.userId,
      'siteChangeFlag': flag
    }

    if (this.sitePreference === 'new') {  
      this.siteUpdated = true;  
      window.setTimeout(() => {
        this.isSiteAffected = false;
      }, 500);
    }

    this.selfService.updateNewSite(siteData).subscribe(data => {
      
      if (data !== null && data !== undefined) {
        this.data.setBanner(true);

        if (this.sitePreference === 'new') {
                window.location.reload();
             } 

        if (this.sitePreference === 'old') {
    
          if(this.manualSiteChange){
              this.isSiteAffected = false;
              this.spinner.hide()  ;
          }else{
            this.siteUpdated = true;
            window.setTimeout(() => {
              this.spinner.hide()  ;
              this.siteUpdated = false;
              this.isSiteAffected = false;
            },1500);
          }
          
        }

      }
    })


  }

  prepareMainMenu() {
    const menuData = [
      // { label: "Home", route: ["/di-home"], id: 10 },
      // { label: "My Site", route: [this.siteHomeRouteConstant], id: 80 }
    ];
    if(this.adminId === '1'){
        menuData.push({ label: "Home", route: ["/bpg-admin-home"], id: 10 });
    }else{
      menuData.push({ label: "Home", route: ["/di-home"], id: 10 });
    }
    menuData.push({ label: "My Site", route: [this.siteHomeRouteConstant], id: 80 });
    this.prepareMembershipMenu(menuData);
  }
  prepareMembershipMenu(menuData) {
    if (this.userType.toUpperCase() === "EMPLOYEE") {
      menuData.push({ label: "Membership Application", route: "/user-membership", id: 30 });
    } else if (this.userType.toUpperCase() === "CORPORATE PARTNER") {
      if (this.corporateType.toUpperCase() === "CONTINGENT" || this.corporateType.toUpperCase() === "TECHNICAL CONTRACTOR") {
        menuData.push({ label: "Membership Application", route: "/user-membership", id: 30 });
      }
    }

    //for expense menu
    if (this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || this.adminId === '4' || this.isbpgAdmin || this.isbpgLeadAdmin || this.isNaacAdmin) {
      menuData.push({ label: "Budget", route: "/expense-list", id: 60 });
    }
    this.prepareMenuPendingEvents(menuData);
  }

  prepareMenuPendingEvents(menuData) {
    if (this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || this.adminId === '4' || this.isNaacAdmin || this.isbpgAdmin || this.isbpgLeadAdmin) {
      menuData.push({ label: "Events", route: "/events", id: 70 });
    }
    this.prepareMenuEventCalender(menuData);
  }
  prepareMenuEventCalender(menuData) {
    menuData.push({ label: "Events Calendar", route: "/events-calendar", id: 50 });
    this.prepareMenuAdmin(menuData);
  }
  prepareMenuAdmin(menuData) {
    if (this.adminId === '1') {
      menuData.push({
        label: "Admin Management", id: 56, children: [
          { label: "Super Admin", route: "/admin", id: 57 },
          { label: "ERG Admin", route: "/chapter-admin", id: 57 },
          { label: "NAAC Admin", route: "/naac-admin", id: 57 },
        ]
      });
    }
    if (this.adminId === '2' || this.leadAdminId === 'true' || this.isbpgLeadAdmin) {
      menuData.push({
        label: "Admin Management", id: 56, children: [
          { label: "ERG Admin", route: "/chapter-admin", id: 57 }
        ]
      });
    }

    this.prepareMenuBudget(menuData);

  }
  prepareMenuBudget(menuData) {
    if (this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || this.adminId === '4' || this.isbpgAdmin || this.isbpgLeadAdmin || this.isNaacAdmin) {
        menuData.push({ label: "Annual Plan", route: "/annual-plan-home", id: 100 });

    }
    // if (this.adminId === '1') {
    //   menuData.push({ label: "Omnidashboard", route: "/omnidashboard", id: 124 });
    // }
    this.prepareMenuReport(menuData);

  }
  prepareMenuReport(menuData) {
    //Commented admin 2 and admin 3 for membership release
    if (this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || this.adminId === '4' || this.isbpgAdmin || this.isbpgLeadAdmin || this.isNaacAdmin) {
      menuData.push({ label: "Reports", reportid: 1 })
    }
    this.prepareBpgMenu(menuData);
  }

  prepareBpgMenu(menuData) {
    this.myBpgsData =
    {
      "filter": {
        "userId": this.logindata1['userId']
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getBPGsList(this.myBpgsData).subscribe(data => {
      if (data) {
        this.myBpgList = data;

        this.data.selectedNavigationBpgs(this.myBpgList);

        if (this.myBpgList.length !== 0) {
          menuData.push({ label: " My ERGs", route: "", id: 20, children: [] });
          for (const k of  menuData) {
            if (k.id === 20) {
              for (let i = 0; i < this.myBpgList.length; i++) {
                k.children.push({ label: this.myBpgList[i]['siteAndBpgName'], bpgId: this.myBpgList[i]['bpgId'], route: "/chapter-home", id: 20 + i + 1, siteId: this.myBpgList[i]['siteId'] })
              }
            }
          }
        }
        this.prepareSelfServiceMenu(menuData);
      }
    });
  }


  prepareSelfServiceMenu(menuData) {
    if (this.adminId === '1') {
      menuData.push({
        label: this.selfServicesConstant, route: this.siteHomeRouteConstant, id: 40, children: [
          // { label: "Areas Of Impact", route: "/area-of-impact-services", id: 41 },
          { label: "ERGs", route: "/erg-services", id: 42 },
          { label: "Chapters", route: this.chapterRoute, id: 43 },
          { label: "Site", route: "/site-services", id: 45 },
          // { label: "Skills", route: "/skills-services", id: 46 },
          { label: "Business and Community Engagement", route: "/BCE-Services", id: 49 },
          { label: this.configureGallery, route: this.configureGalleryRoute, id: 99 },
          { label: this.chapterResources, route: this.chapterResourcesRoute, id: 101 },
          { label: this.chapterAnnouncement, route: this.chapterAnnouncementRoute, id: 105 },
          { label: this.pushNotification, route: this.pushNotificationRoute, id: 106 },
          { label: this.membershipReport, route: this.membershipReportRoute, id: 102 },
          { label: this.emailManagement, route: this.emailManagementRoute, id: 103 },
          { label: "NAAC", route: "/naac", id: 104 },
          { label: this.groupSignUp, route: this.groupSignUpRoute, id:107}
        ]
      });
    }
    else if (this.adminId === '2' || this.adminId === '3' || this.isbpgAdmin || this.isbpgLeadAdmin) {
      menuData.push({
        label: this.selfServicesConstant, route: this.siteHomeRouteConstant, id: 47, children: [
          { label: "Chapters", route: this.chapterRoute, id: 48 },
          { label: this.configureGallery, route: this.configureGalleryRoute, id: 99 },
          { label: this.chapterResources, route: this.chapterResourcesRoute, id: 101 },
          { label: this.chapterAnnouncement, route: this.chapterAnnouncementRoute, id: 105 },
          { label: this.pushNotification, route: this.pushNotificationRoute, id: 106 },
          { label: this.membershipReport, route: this.membershipReportRoute, id: 102 },
          { label: this.emailManagement, route: this.emailManagementRoute, id: 103 },
          { label: "NAAC", route: "/naac", id: 104 },
          { label: this.groupSignUp, route: this.groupSignUpRoute, id:107}

        ]
      });
    }

    else if (this.adminId !== '1' && this.adminId !== '2' && this.adminId !== '3' && this.adminId !== '4' && !this.isbpgAdmin && !this.isNaacAdmin && !this.isbpgLeadAdmin) {

      menuData.push({
        label: this.selfServicesConstant, route: this.siteHomeRouteConstant, id: 47, children: [
          { label: this.emailManagement, route: this.emailManagementRoute, id: 103 },

        ]
      });
    }
    if (this.adminId === '4') {
      menuData.push({
        label: this.selfServicesConstant, route: this.siteHomeRouteConstant, id: 47, children: [
          { label: "NAAC", route: "/naac", id: 104 }
        ]

      });
    }

    if (this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || this.adminId === '4' || this.isNaacAdmin || this.isbpgAdmin || this.isbpgLeadAdmin) {
      this.prepareNaacMenu(menuData);
    }
    else {
      this.prepareSiteMenu(menuData);
    }
  }


  prepareNaacMenu(menuData) {

    const LandingPaginationDTO = {
      "filter": {
        "naacFlag": "naacSelfService",
        "adminId": this.adminId,
        "userId": this.logindata1.userId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "naacId",
      "uid": ""

    }

    this.selfService.getnaacAffinityList(LandingPaginationDTO).subscribe(data => {
      this.naacAffinityList = data;
      this.publishedNaacList = [];
      for (const list of this.naacAffinityList) {
        if (list.naacStatus === 'Publish') {
          this.publishedNaacList.push(list);

        }
      }
      if (this.publishedNaacList.length !== 0) {
        menuData.push({ label: "NAACs", id1: 0, route: "", children: [] });
        for (const menu of menuData) {
          if (menu.label === "NAACs") {
            for (let i = 0; i < this.publishedNaacList.length; i++) {
              menu.children.push({ label: this.publishedNaacList[i].naacAffinityName, naacId: this.publishedNaacList[i].naacId, naacAffinityId: this.publishedNaacList[i].naacAffinityId, route: "/naac-home", id1: i + 1 })
            }
          }
        }

      }      
    menuData.push({ label: "Acknowledgement Form", route: this.tnC, id: 123 });
    })
    this.prepareSiteMenu(menuData)
  }
  childArray: any;
  prepareSiteMenu(menuData) {
    this.siteData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
      this.siteList = data;

      if (this.siteList !== null) {
        for (const site of this.siteList) {
          if (parseInt(localStorage.getItem('selectedSiteId')) === site.siteId) {
            menuData.push({ label: site.siteName, route: this.siteHomeRouteConstant, id: 60, children: [] });

            for (const site1 of this.siteList) {
              menuData[menuData.length - 1].children.push({ label: site1.siteName, route: [this.siteHomeRouteConstant], id: 60 + site1 + 1, 'siteUniqueId': site1.siteId })

            }
          }
        }
      }
    })
    this.links = menuData;
  }

  public childClicked(label, siteId) {
    localStorage.setItem('selectedSiteId', siteId);
    this.selectedSiteId = siteId;
    this.data.selectedSiteIdForSiteMenu(siteId);
    this.links.splice(-1);
    this.links.push({ label: label, route: this.siteHomeRouteConstant, id: 60, children: [] });
    for (let i = 0; i < this.siteList.length; i++) {

      this.links[this.links.length - 1].children.push({ label: this.siteList[i].siteName, route: [this.siteHomeRouteConstant], id: 60 + i + 1, 'siteUniqueId': this.siteList[i].siteId })
    }
    this.clicked();
  }

  childLinkClicked(bpgId, siteId) {
    localStorage.setItem('bpgId', bpgId);
    localStorage.setItem('siteId', siteId);
    const chapterDetailsData = {
      'siteId': siteId,
      'bpgId': bpgId,
      'path': 'myBpg'
    }
    this.data.setMyBpgSiteIdAndBpgId(chapterDetailsData);
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  childLinkClickedNaac(naacId, naacName, naacAffinityId) {
    const naacDetails = {
      "naacId": naacId,
      "naacName": naacName,
      "naacAffinityId": naacAffinityId
    }
    localStorage.setItem('selectedNaacId', naacId);
    localStorage.setItem('selectedNaacName', naacName);
    localStorage.setItem('naacAffinityId', naacAffinityId);
    this.data.selectednaacIdForNaacMenu(naacDetails);

  }
  isSiteClassVisible() {
    this.isClassVisible = true;
  }

  goToReport() {
    this.logUserAction();
    window.open("https://app.powerbi.com/groups/me/apps/0d0ac254-5b0f-4b27-a747-18a5f4e48961/reports/ab2d6f8d-1289-4a56-b325-77b5d7596ecd/ReportSection", "_blank", "noopener");
  }
  clicked() {
    if (window.innerWidth <= 1200) {
      document.getElementById("collapseBtn").click();
    }
  }
  home() {
    localStorage.setItem('selectedSiteId', this.userSiteId);
    this.userSiteId = localStorage.getItem('selectedSiteId');
    this.data.selectedSiteIdForSiteMenu(this.userSiteId);
    this.ngOnInit();
    this.clicked();
  }
  updateEmail() {
    this.email = document.getElementById("email");
    this.email = this.email.value;

    const landingData = {
      "createdBy": this.logindata1.userId,
      "createdDateTime": new Date(),
      "isActive": true,
      "modifiedBy": new Date(),
      "modifiedDateTime": new Date(),
      "userId": this.logindata1.userId,
      "emailId": this.email
    }
    this.adminService.updateEmail(landingData).subscribe(data => {
      if (data !== null) {
        this.alertSuccess = true;
        this.showPopUp = false;
        localStorage.setItem("emailUpdated", 'true');
      }
    });


  }


  logUserAction() {
    const data = {
      userId : this.userData['userId'],
      categoryDescription : "Reports"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }



}


